import React, { useState, useEffect, useRef } from "react";
import { Popover } from "antd";

import { FaLocationDot } from "react-icons/fa6";

import UniversityInfoModal from "./university-info-modal";
import { Images } from "../../config";

import "./styles.css";

const GridViewCard = (props) => {
  const cardRef = useRef(null);

  const { data, setIsPopoverOpen, containerRef } = props;

  const [showModal, setShowModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.intersectionRatio >= 0.9);
      },
      {
        root: containerRef.current,
        rootMargin: "0px",
        threshold: [0.9],
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [containerRef]);

  const popoverContent = (
    <div className="university-grid">
      <div
        className="w-full rounded-t-lg relative h-[8.75em] cursor-pointer"
        style={{
          background: `url(${data?.campusPic ?? Images.DefaultUniCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onClick={() => setShowModal(true)}
      >
        <div className="absolute inset-0 bg-black opacity-50 rounded-t-lg"></div>
        <div className="relative p-3 flex flex-col gap-2 overflow-y-auto text-white">
          <img
            src={data?.profilePic ?? Images.LogoIconOnly}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
            className="h-[2.625em] w-[2.625em] border border-searchBorder shadow-boxContainer rounded-full object-contain bg-white"
          />
          <div className="flex flex-col gap-2">
            <div className="font-bold text-[0.875em] line-clamp-2 overflow-hidden text-ellipsis">
              {data?.name}
            </div>
            <div className="flex gap-1 items-center font-semibold">
              <div className="text-[0.75em] mb-1 text-white">
                <FaLocationDot />
              </div>
              <div className="flex items-center text-[0.625em]">
                {data?.city && `${data?.city}`}
                {data?.state && `, ${data?.state}`}
                {data?.country?.name && `, ${data?.country.name}`}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex flex-col p-2 py-3 gap-2 cursor-pointer"
        onClick={() => setShowModal(true)}
      >
        <div className="grid-popover-value-container">
          <div>Average Course Duration: </div>
          {data?.courseDuration ? (
            <div className="grid-popover-value">{data?.courseDuration}</div>
          ) : (
            "NA"
          )}
        </div>
        <div className="grid-popover-value-container">
          <div>Average Fee: </div>
          {data?.avgFeesUSD ? (
            <div className="grid-popover-value">
              USD {data?.avgFeesUSD?.toLocaleString()}
            </div>
          ) : (
            "NA"
          )}
        </div>
        <div className="grid-popover-value-container">
          <div>Acceptance Rate: </div>
          {data?.acceptanceRate ? (
            <div className="grid-popover-value">
              {(data?.acceptanceRate * 100).toFixed(1)}%
            </div>
          ) : (
            "NA"
          )}
        </div>
        <div className="grid-popover-value-container">
          <div>Application Status: </div>
          {data?.deadlines?.length > 0 ? (
            data?.deadlines[0]?.appDeadline ? (
              new Date() > new Date(data?.deadlines[0]?.appDeadline) ? (
                <span className="bg-red-500 text-white font-medium px-1 pt-1 pb-0.5 rounded-md ml-1 text-[0.825em]">
                  CLOSED
                </span>
              ) : (
                <span className="bg-green-500 text-white font-medium px-1 pt-1 pb-0.5 rounded-lg ml-1 text-[0.825em]">
                  OPEN
                </span>
              )
            ) : (
              "NA"
            )
          ) : (
            "NA"
          )}
        </div>
        <div className="grid-popover-value-container">
          <div>Avg. Fresh Grad Salary: </div>
          {data?.freshGradSalary ? (
            <span className="grid-popover-value">
              USD {data?.freshGradSalary?.toLocaleString()}
            </span>
          ) : (
            "NA"
          )}
        </div>
      </div>
    </div>
  );
  return (
    <Popover
      content={popoverContent}
      trigger={isVisible ? "hover" : null}
      arrow={false}
      overlayInnerStyle={{
        position: "absolute",
        padding: "0px",
        top: `-15.6em`,
        right: "-9.6875em",
      }}
      onOpenChange={setIsPopoverOpen}
      getPopupContainer={(trigger) => trigger.parentElement}
    >
      <div className="university-grid" ref={cardRef}>
        <img
          src={data?.campusPic ?? Images.DefaultUniCover}
          className="w-full object-cover rounded-t-lg h-[8.75em] relative"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = Images.DefaultUniCover;
          }}
        />
        {props?.shownumber && (
          <div className="absolute w-full bg-[#0000005e] pl-5 text-white opacity-60 text-[5.75em] font-semibold  rounded-t-md flex items-center">
            {props?.index + 1}
          </div>
        )}
        <div className="p-3 flex gap-[0.625em] h-[6.25em] overflow-hidden items-center">
          <img
            src={data?.profilePic ?? Images.LogoIconOnly}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
            className="h-[2.625em] w-[2.625em] border border-searchBorder shadow-boxContainer rounded-full object-contain bg-white"
          />
          <div className="flex flex-col gap-2">
            <div
              className="font-bold text-[0.875em] line-clamp-2 overflow-hidden text-ellipsis"
              title={data?.name}
            >
              {data?.name}
            </div>
            <div className="flex gap-1 items-center font-semibold">
              <div className="text-[0.875em] mb-1 text-main">
                <FaLocationDot />
              </div>
              <div className="flex items-center text-[0.75em]">
                {data?.city && `${data?.city}`}
                {data?.state && `, ${data?.state}`}
                {data?.country?.name && `, ${data?.country.name}`}
              </div>
            </div>
          </div>
        </div>
      </div>
      <UniversityInfoModal
        uniId={data.id}
        open={showModal}
        onCancel={() => setShowModal(false)}
      />
    </Popover>
  );
};

export default GridViewCard;
